module.exports = __webpack_public_path__ + "static/media/news-qrcode-registration.fe6ca284.png";